import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import {
  KibThumbdownFillIcon,
  KibThumbdownOutlineIcon,
  KibThumbupFillIcon,
  KibThumbupOutlineIcon,
} from '@chewy/kib-icons-react'
import classNames from 'classnames'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapFeedbackButton.module.scss'

export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export interface RhapFeedbackButtonProps {
  className?: string
  disabled?: boolean
  isSelected?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  type: FeedbackType
}

const RhapFeedbackButton = forwardRef<
  HTMLButtonElement,
  RhapFeedbackButtonProps
>(({ className, disabled, isSelected = false, onClick, type }, ref) => {
  const { t } = useTranslation('Agent')

  const isPositive = type === FeedbackType.POSITIVE
  const label = isPositive
    ? t('Agent:FEEDBACK_POSITIVE')
    : t('Agent:FEEDBACK_NEGATIVE')

  const icon = isPositive ? (
    isSelected ? (
      <KibThumbupFillIcon />
    ) : (
      <KibThumbupOutlineIcon />
    )
  ) : isSelected ? (
    <KibThumbdownFillIcon />
  ) : (
    <KibThumbdownOutlineIcon />
  )

  return (
    <KibButtonNew
      aria-label={label}
      className={classNames(styles.feedbackButton, className)}
      disabled={disabled}
      emphasis="secondary"
      icon={icon}
      iconPosition="start"
      ref={ref}
      size="small"
      theme="utility"
      title={label}
      onClick={onClick}
    >
      {label}
    </KibButtonNew>
  )
})

RhapFeedbackButton.displayName = 'RhapFeedbackButton'

export default RhapFeedbackButton
